export default __webpack_public_path__ + "static/media/icon-question-green.baa07a86.svg";